export default __webpack_public_path__ + "static/media/1771.4c7da066.png";